import React from "react";
import "./styles/Loader.css";
const Spinner = require('react-spinkit');

const Loader = () => (
 <div>
     <p>adasds</p>
     <div className="overlay" style={{display:"flex"}}><Spinner className="spinner" name='line-scale' color="#9820e0"/></div>
 </div>
);

export default Loader;
